"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgCadDrawingOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M8 13.08v6.56l6 3.22 6-3.22v-6.56l-6-3.21zm8.88.6L14 15.23l-2.89-1.55L14 12.13zM10 15.35L13 17v3.1l-3-1.61zm5 4.71V17l3-1.61v3.1z" }),
        React.createElement("path", { d: "M25.72 3H23v3H3v21h22.72A3.26 3.26 0 0029 23.75V6.25A3.26 3.26 0 0025.72 3zm0 22H5V8h18v14.5h2.75a1.25 1.25 0 010 2.5zM27 20.75a3.28 3.28 0 00-1.25-.25H25V5h.75A1.25 1.25 0 0127 6.25z" })));
}
exports.default = SvgCadDrawingOutline;
//# sourceMappingURL=CadDrawingOutline.js.map